
// ! rename the function to align with the widget name
export const menuMaker = () => {
    const el = document.querySelector('.curious-menu-maker');
    if (!el) return;

    // ------------------------------------------------------------
            const menuToggles = document.querySelectorAll('.menu-maker .menu-toggle');
            
            menuToggles.forEach(function(toggle) {
                toggle.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const menuItem = this.closest('.menu-item');
                    const submenu = menuItem.querySelector('.submenu');
                    const isExpanded = this.getAttribute('aria-expanded') === 'true';
                    
                    // Toggle the expanded state
                    if (isExpanded) {
                        this.setAttribute('aria-expanded', 'false');
                        this.classList.remove('expanded');
                        this.classList.add('collapsed');
                        menuItem.classList.remove('expanded');
                        submenu.classList.remove('expanded');
                    } else {
                        this.setAttribute('aria-expanded', 'true');
                        this.classList.remove('collapsed');
                        this.classList.add('expanded');
                        menuItem.classList.add('expanded');
                        submenu.classList.add('expanded');
                    }
                });
            });

   

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

